import classNames from "classnames"
import { Popover } from "../Popover"
import styles from "./styles.module.scss"
import MoreHorizontalOutline from "~icons/eva/more-horizontal-outline"
import { PopoverAlign } from "react-tiny-popover"

type Option = {
  label: string
  onClick: () => void
  icon?: React.ReactNode
  danger?: boolean
  isHidden?: boolean
}

export const OptionPopover = ({
  options,
  isOpen,
  onClose,
  testId,
  openPopover,
  moreButtonClassName,
  moreButtonRef,
  onMouseDown,
  onMouseUp,
  wrapperClassName,
  align,
}: {
  options: Option[]
  isOpen: boolean
  onClose: (e?: MouseEvent) => void
  testId: string
  openPopover: (e?: React.MouseEvent<HTMLDivElement>) => void
  moreButtonClassName?: string
  moreButtonRef?: React.RefObject<HTMLDivElement>
  onMouseDown?: (e: React.MouseEvent<HTMLDivElement>) => void
  onMouseUp?: (e: React.MouseEvent<HTMLDivElement>) => void
  wrapperClassName?: string
  align: PopoverAlign
}) => {
  return (
    <Popover
      isOpen={isOpen}
      title={""}
      positions={["bottom"]}
      zIndex={999}
      align={align}
      padding={6}
      wrapperClassName={isOpen ? classNames(styles.optionsPopoverWrapper, wrapperClassName) : ""}
      onClickOutside={(e) => onClose(e)}
      content={
        <div className={styles.optionsPopover}>
          {options.map((option) =>
            option.isHidden ? null : (
              <div
                key={option.label}
                className={classNames(styles.option, option.danger ? styles.danger : "")}
                onClick={option.onClick}
                data-testid={`${testId}-${option.label.toLowerCase().replace(" ", "-")}-button`}
              >
                {option.icon}
                {option.label}
              </div>
            ),
          )}
        </div>
      }
    >
      <div
        role="button"
        onClick={(e) => openPopover(e)}
        className={classNames(styles.moreButton, moreButtonClassName)}
        data-testid={`${testId}-more-button`}
        ref={moreButtonRef}
        onMouseDown={(e) => onMouseDown?.(e)}
        onMouseUp={(e) => onMouseUp?.(e)}
      >
        <MoreHorizontalOutline className={styles.moreButtonIcon} />
      </div>
    </Popover>
  )
}
